import { MutableRefObject } from 'react';

import { isInList } from '../../../../../../common/inList/inListUtils';
import { getContainerWidth, getTableScrollableElement } from '../../domUtils/tableDomQueryUtils';

/**
 * Returns the pixel width a table should resize toward when it is rendered inside a list container.
 */
export const getColWidthsInList = (
    inList: string | undefined,
    hotTableContainerRef: MutableRefObject<HTMLDivElement | null>,
    getContextZoomScale?: () => number,
): number | null => {
    if (!isInList(inList)) return null;

    const resizeToWidth =
        getContainerWidth(hotTableContainerRef.current) ||
        getTableScrollableElement(hotTableContainerRef.current)?.scrollWidth;

    if (!resizeToWidth) return null;

    const zoomScale = getContextZoomScale ? getContextZoomScale() : 1;
    return resizeToWidth / zoomScale;
};
